import styled from 'styled-components';
import { system } from 'styled-system';
import { Flex } from '../flex';

export interface StackProps {
  gap?: number | string | number[];
}

const Stack = styled(Flex)<StackProps>(
  system({
    gap: {
      property: 'gap',
      scale: 'space',
      transform: (value, scale) => {
        if (scale && Array.isArray(scale) && scale[value] !== undefined) {
          return scale[value];
        }

        return value;
      },
    },
  })
);

export { Stack };
